(() => {
  // --- State ---
  const sizes = (window.EK_SIZEFINDER_SIZES || []).slice().sort((a, b) => a.length - b.length);
  // New charts set recommendFrom per size; legacy Hausschuhe leave it null → 0.4 bump logic
  const useRecommendFrom = sizes.some((s) => s.recommendFrom != null);
  // ponytail: hardcoded defaults mirror Liquid; metaobject fills window.EK_SIZEFINDER_COPY when set
  const copy = Object.assign(
    {
      recommendationExact:
        "Damit die Schuhe bequem sitzen und dein Kind lange Freude daran hat, empfehlen wir bei einer Fußlänge von {{length}} cm die Schuhgröße:",
      recommendationBump:
        "Bei einer Fußlänge von {{length}} cm würde die Schuhgröße {{exact_size}} noch passen. Damit dein Kind aber länger Freude daran hat, empfehlen wir dir die Größe:",
      recommendationSmallest:
        "Bei einer Fußlänge von {{length}} cm empfehlen wir die kleinste verfügbare Größe, damit dein Kind lange Freude daran hat:",
      selectSizeLabel: "Schuhgröße {{size}} auswählen",
      selectSizeSelected: "Schuhgröße {{size}} ausgewählt",
      tooSmallText:
        "Bei einer Fußlänge von {{length}} cm ist der Kinder-Hausschuh zu groß für die Füße. Wir empfehlen dir unsere {{product_link}} in Größe",
      tooSmallLinkLabel: "Baby-Walkschühchen",
      tooSmallUrl: "/products/walkschuehchen",
      tooSmallNoAlternativeText: "Bei einer Fußlänge von {{length}} cm ist der Schuh leider zu groß für die Füße.",
      tooLargeText: "Bei einer Fußlänge von {{length}} cm ist der Kinder-Hausschuh leider zu klein für die Füße.",
      hideTooSmallAlternative: false,
    },
    window.EK_SIZEFINDER_COPY || {},
  );
  // Add baby shoe sizes (only first 3, as per image)
  const babySizes = [
    { size: '17/18', min: 10.8, max: 11.4 },
    { size: '19/20', min: 11.4, max: 12.6 },
    { size: '21/22', min: 12.6, max: 13.8 },
  ];
  const modal = document.querySelector("[data-sizefinder-modal]");
  const openBtn = document.querySelector("[data-sizefinder-open]");
  const closeBtn = document.querySelector("[data-sizefinder-close]");
  const backBtn = document.querySelector("[data-sizefinder-back]");
  const stepSections = document.querySelectorAll("[data-sizefinder-step]");
  const stepper = document.querySelectorAll("[data-step-indicator]");
  const continueBtns = document.querySelectorAll("[data-sizefinder-continue]");
  const stepsContainer = document.querySelector("[data-sizefinder-steps]");
  const liveRegion = document.getElementById("sizefinder-live");
  const selectSizeBtn = document.querySelector("[data-select-size]");
  const selectSizeText = document.querySelector("[data-select-size-text]");
  const recommendedSizeEl = document.querySelector("[data-recommended-size]");
  const recommendationDetailEl = document.querySelector("[data-recommendation-detail]");
  const comfortTextEl = document.querySelector("[data-comfort-text]");
  const tooSmallBodyEl = document.querySelector("[data-too-small-body]");
  const tooLargeBodyEl = document.querySelector("[data-too-large-body]");
  const footLengthInput = document.querySelector("[data-foot-length]");
  let currentStep = 0;
  let footLength = null;
  let scrollPosition = 0;

  function fillTemplate(tpl, vars) {
    return String(tpl || "").replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, (placeholder, key) =>
      vars[key] != null ? String(vars[key]) : placeholder,
    );
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  // --- Accessibility helpers ---
  function trapFocus(element) {
    const focusableEls = element.querySelectorAll('a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])');
    const firstFocusable = focusableEls[0];
    const lastFocusable = focusableEls[focusableEls.length - 1];
    function handleTab(e) {
      if (e.key !== "Tab") return;
      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
    element.addEventListener("keydown", handleTab);
    return () => element.removeEventListener("keydown", handleTab);
  }

  // --- Stepper UI ---
  function updateStepper() {
    // There are 3 steps (1, 2, 3), corresponding to indices 1, 2, 3 (not including intro step 0)
    stepper.forEach((el, idx) => {
      const stepNum = idx + 1;
      el.className =
        "w-[20.6px] h-[20.6px] pt-[1px] text-secondary flex items-center text-sm justify-center rounded-full border font-bold transition-colors duration-300 bg-white mx-auto leading-none";
      el.style.borderColor = "#b2b2b2"; // Tailwind gray-200
      el.style.color = "#b2b2b2"; // Tailwind gray-500
      el.style.fontWeight = "normal";
      el.innerHTML = stepNum;
      if (currentStep > stepNum) {
        // Completed step: green bg, checkmark SVG, NO border
        el.classList.add("bg-[#74A19C]");
        el.classList.remove("border-[#74A19C]");
        el.style.borderColor = "transparent";
        el.innerHTML = `<svg width="22" height="22" class="flex-shrink-0" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10.9" cy="10.9" r="10.4" fill="#74A19C" stroke="#74A19C"/>
<path d="M5.75961 11.4116L9.22115 14.3269L15.2788 7.66345" fill="#74A19C"/>
<path d="M5.75961 11.4116L9.22115 14.3269L15.2788 7.66345" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


`;
      } else if (currentStep === stepNum) {
        // Active step: green border, green text
        el.classList.add("border-[#74A19C]");
        el.style.borderColor = "#74A19C";
        el.style.color = "#74A19C";
        el.style.fontWeight = "bold";
      }
    });
  }

  // --- Step Navigation ---
  function showStep(step) {
    const panels = document.querySelector("[data-sizefinder-panels]");

    // Accessibility: handle aria-hidden and inert for all steps
    const allStepSections = document.querySelectorAll('[data-sizefinder-step]');
    // Move focus to the new step FIRST
    const newStepSection = document.querySelector(`[data-sizefinder-step="${step}"]`);
    if (newStepSection) {
      const focusable = newStepSection.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusable) focusable.focus();
    }
    // Set aria-hidden and inert on all steps
    allStepSections.forEach((section, idx) => {
      if (parseInt(section.getAttribute('data-sizefinder-step')) !== step) {
        section.setAttribute('aria-hidden', 'true');
        section.setAttribute('inert', '');
      } else {
        section.setAttribute('aria-hidden', 'false');
        section.removeAttribute('inert');
      }
    });

    // Show panels and slide to the correct step
    if (panels) {
      panels.classList.remove("hidden");
      panels.style.transform = `translateX(-${step * 100}%)`;
    }
    
    currentStep = step;
    updateStepper();
    // Hide stepper and back button on step 0
    document.querySelectorAll("[data-sizefinder-hide-on-step0]").forEach((el) => {
      if (step === 0) {
        el.classList.add("hidden");
      } else {
        el.classList.remove("hidden");
      }
    });
    // Accessibility: announce step
    if (liveRegion) {
      const stepTitles = ["Start", "Messen", "Prüfen", "Empfehlung"];
      liveRegion.textContent = `Schritt ${step} von 3: ${stepTitles[step]}`;
    }
    // Back button visibility (for steps > 1)
    if (backBtn) {
      backBtn.disabled = step <= 1;
      backBtn.setAttribute("aria-disabled", step <= 1 ? "true" : "false");
      backBtn.classList.toggle("opacity-50", step <= 1);
      backBtn.classList.toggle("pointer-events-none", step <= 1);
      // Hide back button on step 1 since we don't show intro again
      backBtn.classList.toggle("hidden", step <= 1);
    }
  }

  // --- Modal Open/Close ---
  function openModal() {
    modal.classList.remove("hidden");
    document.documentElement.classList.add("sizefinder-open");
    showStep(0);
    document.body.style.overflow = "hidden";
    
    // Add slide-in animation
    const modalContent = document.querySelector("[data-sizefinder-content]");
    const modalBackground = document.querySelector("[data-sizefinder-background]");
    
    if (modalBackground) {
      modalBackground.classList.add("animate-overlay-background");
    }
    
    if (modalContent) {
      modalContent.classList.add("animate-slide-in");
    }
    
    // Remove autofocus behavior - let user interact naturally
  }

  function closeModal(afterCloseCallback) {
    const modalContent = document.querySelector("[data-sizefinder-content]");
    const modalBackground = document.querySelector("[data-sizefinder-background]");
    
    // Add slide-out animation
    if (modalBackground) {
      modalBackground.classList.add("animate-overlay-background-reverse");
    }
    
    if (modalContent) {
      modalContent.classList.add("animate-slide-out");
    }
    
    // Wait for animation to complete before hiding
    setTimeout(() => {
      document.documentElement.classList.remove("sizefinder-open");
      modal.classList.add("hidden");
      document.body.style.overflow = "";
      // Remove animation classes
      if (modalBackground) {
        modalBackground.classList.remove("animate-overlay-background-reverse");
      }
      if (modalContent) {
        modalContent.classList.remove("animate-slide-out");
      }
      // Reset to intro step after modal is hidden
      showStep(0);
      if (openBtn) openBtn.focus();
      if (typeof afterCloseCallback === 'function') {
        setTimeout(afterCloseCallback, 10);
      }
    }, 250); // Match animation duration
  }

  function goBack() {
    if (currentStep > 0) showStep(currentStep - 1);
  }

  // --- Recommendation Logic ---
  function lowerLimit() {
    if (!sizes.length) return 0;
    if (useRecommendFrom) return Math.min(...sizes.map((s) => s.recommendFrom ?? s.length));
    return sizes[0].length;
  }

  function upperLimit() {
    if (!sizes.length) return 0;
    if (useRecommendFrom) {
      const withMax = sizes.filter((s) => s.maxCm != null);
      if (withMax.length) return Math.max(...withMax.map((s) => s.maxCm));
      return Math.max(...sizes.map((s) => s.length));
    }
    return sizes[sizes.length - 1].length;
  }

  function calculateSize(length) {
    if (!sizes.length) return null;

    if (useRecommendFrom) {
      let best = null;
      let bestFrom = -Infinity;
      for (const s of sizes) {
        const from = s.recommendFrom ?? s.length;
        if (length >= from && from >= bestFrom) {
          bestFrom = from;
          best = s.size;
        }
      }
      return best;
    }

    const EDGE_CASE_THRESHOLD = 0.4;
    if (length < sizes[0].length) return sizes[0].size;
    if (length >= sizes[sizes.length - 1].length) return sizes[sizes.length - 1].size;
    for (let i = 0; i < sizes.length - 1; i++) {
      const currentSize = sizes[i];
      const nextSize = sizes[i + 1];
      if (length >= currentSize.length && length < nextSize.length) {
        const distanceToNextSize = nextSize.length - length;
        if (distanceToNextSize <= EDGE_CASE_THRESHOLD) {
          return nextSize.size;
        } else {
          return currentSize.size;
        }
      }
    }
    return null;
  }

  function exactFitSize(length) {
    return sizes.find((s, idx) => s.length <= length && (!sizes[idx + 1] || sizes[idx + 1].length > length));
  }

  function markStep3Complete() {
    const step3Indicator = document.querySelector('[data-step-indicator="3"]');
    if (!step3Indicator) return;
    step3Indicator.classList.add("bg-[#74A19C]");
    step3Indicator.classList.remove("border-[#74A19C]");
    step3Indicator.style.borderColor = "transparent";
    step3Indicator.innerHTML = `<svg width="22" height="22" class="flex-shrink-0" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10.9" cy="10.9" r="10.4" fill="#74A19C" stroke="#74A19C"/>
<path d="M5.75961 11.4116L9.22115 14.3269L15.2788 7.66345" fill="#74A19C"/>
<path d="M5.75961 11.4116L9.22115 14.3269L15.2788 7.66345" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
  }

  function bindSelectSize(recommendedSize) {
    let selected = false;
    selectSizeBtn.onclick = () => {
      if (!selected) {
        const sizeSelect = document.querySelector('select[name="options[Größe]"]');
        if (sizeSelect) {
          sizeSelect.value = recommendedSize;
          sizeSelect.dispatchEvent(new Event("change", { bubbles: true }));
        }
        selectSizeText.textContent = fillTemplate(copy.selectSizeSelected, { size: recommendedSize });
        selected = true;
        markStep3Complete();
        setTimeout(() => {
          closeModal(() => {
            document.querySelector("variant-selects")?.scrollIntoView({ behavior: "smooth", block: "center" });
          });
        }, 450);
      } else {
        closeModal(() => {
          document.querySelector("variant-selects")?.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
    };
  }

  function renderTooSmallBody(formattedLength) {
    if (!tooSmallBodyEl) return;
    const productLink = `<a href="${escapeHtml(copy.tooSmallUrl)}" class="underline">${escapeHtml(copy.tooSmallLinkLabel)}</a>`;
    tooSmallBodyEl.innerHTML = fillTemplate(copy.tooSmallText, {
      length: formattedLength,
      product_link: productLink,
    });
  }

  function showRecommendation(length) {
    if (!recommendationDetailEl || !recommendedSizeEl || !comfortTextEl || !selectSizeText) return;
    const formattedLength = length.toLocaleString("de-DE", { minimumFractionDigits: 0, maximumFractionDigits: 1 });
    const normalRec = document.querySelector("[data-recommendation-normal]");
    const tooSmallRec = document.querySelector("[data-recommendation-too-small]");
    const tooLargeRec = document.querySelector("[data-recommendation-too-large]");
    const bottomBackBtn = document.querySelector('[data-sizefinder-step="3"] > button[data-sizefinder-back-secondary]');
    const minCm = lowerLimit();
    const maxCm = upperLimit();
    let recommendedSize = calculateSize(length);

    // Special case: if length is above 12.7cm but still below chart min, recommend smallest regular size
    if (length > 12.7 && length < minCm) {
      if (normalRec) normalRec.classList.remove("hidden");
      if (tooSmallRec) tooSmallRec.classList.add("hidden");
      if (tooLargeRec) tooLargeRec.classList.add("hidden");

      recommendedSize = sizes[0].size;
      recommendationDetailEl.textContent = fillTemplate(copy.recommendationSmallest, { length: formattedLength });
      selectSizeText.textContent = fillTemplate(copy.selectSizeLabel, { size: recommendedSize });
      recommendedSizeEl.textContent = recommendedSize;
      comfortTextEl.textContent = "";
      if (bottomBackBtn) bottomBackBtn.classList.remove("hidden");
      bindSelectSize(recommendedSize);
      showStep(3);
      return;
    }

    if (length < minCm) {
      if (normalRec) normalRec.classList.add("hidden");
      if (copy.hideTooSmallAlternative) {
        // No alternative product: same UX as too-large (message + re-enter), no Walkschühchen link
        if (tooSmallRec) tooSmallRec.classList.add("hidden");
        if (tooLargeRec) tooLargeRec.classList.remove("hidden");
        if (tooLargeBodyEl) {
          tooLargeBodyEl.textContent = fillTemplate(copy.tooSmallNoAlternativeText, { length: formattedLength });
        }
        if (bottomBackBtn) bottomBackBtn.classList.add("hidden");
      } else {
        const babySize = babySizes.find((bs) => length >= bs.min && length < bs.max) || babySizes[0];
        if (tooSmallRec) tooSmallRec.classList.remove("hidden");
        if (tooLargeRec) tooLargeRec.classList.add("hidden");
        const babySizeText = tooSmallRec?.querySelector(".text-ek-black.font-display");
        if (babySizeText) babySizeText.textContent = babySize.size;
        renderTooSmallBody(formattedLength);
        if (bottomBackBtn) bottomBackBtn.classList.remove("hidden");
      }
      showStep(3);
      return;
    }

    if (length > maxCm) {
      if (normalRec) normalRec.classList.add("hidden");
      if (tooSmallRec) tooSmallRec.classList.add("hidden");
      if (tooLargeRec) tooLargeRec.classList.remove("hidden");
      if (tooLargeBodyEl) tooLargeBodyEl.textContent = fillTemplate(copy.tooLargeText, { length: formattedLength });
      if (bottomBackBtn) bottomBackBtn.classList.add("hidden");
      showStep(3);
      return;
    }

    if (normalRec) normalRec.classList.remove("hidden");
    if (tooSmallRec) tooSmallRec.classList.add("hidden");
    if (tooLargeRec) tooLargeRec.classList.add("hidden");
    if (bottomBackBtn) bottomBackBtn.classList.remove("hidden");

    const exact = exactFitSize(length);
    if (exact && exact.size !== recommendedSize) {
      recommendationDetailEl.textContent = fillTemplate(copy.recommendationBump, {
        length: formattedLength,
        exact_size: exact.size,
      });
    } else {
      recommendationDetailEl.textContent = fillTemplate(copy.recommendationExact, { length: formattedLength });
    }
    selectSizeText.textContent = fillTemplate(copy.selectSizeLabel, { size: recommendedSize });
    recommendedSizeEl.textContent = recommendedSize;
    comfortTextEl.textContent = "";
    bindSelectSize(recommendedSize);
    showStep(3);
  }

  // --- Event Handlers ---
  function handleContinue(e) {
    if (currentStep === 0) {
      showStep(1);
    } else if (currentStep === 1) {
      showStep(2);
    } else if (currentStep === 2) {
      if (footLengthInput && footLengthInput.value) {
        footLength = parseFloat(footLengthInput.value);
        showRecommendation(footLength);
      } else if (footLengthInput) {
        footLengthInput.focus();
      }
    }
  }

  // --- Animate next button on input ---
  if (footLengthInput) {
    const inputStepContinueBtn = footLengthInput.closest("form")?.querySelector("[data-sizefinder-continue]");
    const nextTextSpan = inputStepContinueBtn?.querySelector(".sizefinder-next-text");
    footLengthInput.addEventListener("input", () => {
      if (inputStepContinueBtn && nextTextSpan) {
        if (footLengthInput.value && !isNaN(footLengthInput.value.replace(",", "."))) {
          inputStepContinueBtn.classList.add("sizefinder-continue--active");
        } else {
          inputStepContinueBtn.classList.remove("sizefinder-continue--active");
        }
      }
    });
  }

  // --- Keyboard & Modal Events ---
  if (openBtn) openBtn.addEventListener("click", openModal);
  if (closeBtn) closeBtn.addEventListener("click", () => closeModal());
  if (backBtn) backBtn.addEventListener("click", goBack);
  continueBtns.forEach((btn) => btn.addEventListener("click", handleContinue));
  // Secondary back button in step 3
  const backSecondaryBtns = document.querySelectorAll("[data-sizefinder-back-secondary]");
  backSecondaryBtns.forEach((btn) => {
    btn.addEventListener("click", () => showStep(2));
  });
  if (modal) {
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });
  }
  document.addEventListener("keydown", (e) => {
    if (!modal.classList.contains("hidden")) {
      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowLeft" && currentStep > 1) goBack();
      if (e.key === "Enter" && document.activeElement === footLengthInput && currentStep === 2) {
        handleContinue();
      }
    }
  });
  if (footLengthInput) {
    footLengthInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleContinue();
      }
    });
  }

  // --- Accessibility: focus trap ---
  let removeTrap = null;
  if (modal) {
    modal.addEventListener("transitionend", () => {
      if (!modal.classList.contains("hidden")) {
        removeTrap = trapFocus(modal);
      } else if (removeTrap) {
        removeTrap();
      }
    });
  }
})();
